import styled from "styled-components";

export const StyledIcon = styled.svg`
  flex: none;
  height: 22px;
  width: 22px;
`;
